{
  "imprint-page": {
    "meta": {
      "title": "Beauty Booking: Otisk",
      "description": "Otisk"
    },
    "text": {
      "title": "Otisk",
      "address-and-contact-data": "ADRESA A KONTAKTNÍ ÚDAJE PODLE § 5 TMG",
      "address": "Adresa",
      "commercial-register": "Obchodní rejstřík",
      "contact": "Kontakt",
      "email": "Email",
      "legal-representatives": "Právní zástupci",
      "liability": "ZODPOVĚDNOST",
      "liability-text-1": "Za obsah našich webových stránek odpovídáme v souladu s ustanoveními obecných právních předpisů, zejména v souladu s § 7 odst. 1 německého zákona o telemédiích (TMG). Veškerý obsah je vytvořen s náležitou péčí a podle našeho nejlepšího vědomí. Pokud prostřednictvím hypertextových odkazů na našich webových stránkách odkazujeme na webové stránky třetích stran, nemůžeme převzít žádnou záruku za trvalou aktuálnost, správnost a úplnost odkazovaného obsahu, protože tento obsah leží mimo naši oblast odpovědnosti a na jeho budoucí podobu nemáme žádný vliv. Pokud podle vašeho názoru některý obsah porušuje platné právní předpisy nebo je nevhodný, informujte nás o tom.",
      "liability-text-2": "Právní informace na této stránce, jakož i veškeré dotazy a spory v souvislosti s designem těchto webových stránek podléhají zákonům Spolkové republiky Německo.",
      "telephone": "Telefon",
      "vat-id": "ID DPH (Ust-ID)"
    }
  }
}
